import { Middleware, MiddlewareAPI, SerializedError } from "@reduxjs/toolkit";
import CommonSlice from "src/store/Slices/CommonSlice";
export const apiMiddleware: Middleware =
    (api: MiddlewareAPI) => (next) => (action) => {
        
        if (action.error) {
            if (action?.payload) {
                const sError: SerializedError = action.payload;
                api.dispatch(CommonSlice.actions.setError(sError.message))
            }
        }
        return next(action)
    }